'use strict';

var mobile = require('../third-party/mobile');
var hasParentClass = require('../utilities/domHelpers');

var $app;
var $menuBtn;
var eventType = mobile() ? 'touchstart' : 'click';

var handleBodyClick = function handleBodyClick(evt) {
    if (!hasParentClass(evt.target, 'sidebar') || hasParentClass(evt.target, 'scroll-btn')) {
        $app.removeClass('sidebar-menu-open');
        document.removeEventListener(eventType, handleBodyClick);
    }
};

var init = function init() {
    $app = $('#app');
    $menuBtn = $('#menu-btn');

    $menuBtn.on('click', function() {
        $app.addClass('sidebar-menu-open');
        setTimeout(function() {
            document.addEventListener(eventType, handleBodyClick)
        }, 1);
    });
};

module.exports = function() {
    init();
}



// WEBPACK FOOTER //
// ./resources/js/components/sidebarNav.js